import React from "react"

import * as style from "./style.module.scss"

const Modal = ({ children, show, onClose }) => (
  <div className={style.modal} data-show={show}>
    <div className={style.background} onClick={onClose} />
    <section>{children}</section>
  </div>
)

export default Modal
